"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyForTheNextStep() {
  return <section id="klaar-voor-de-volgende-stap" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative">
        {}
        <div className="relative rounded-[var(--radius-xl)] overflow-hidden bg-gradient-to-br from-primary via-secondary to-chart-4 p-12 sm:p-20 lg:p-32 text-center shadow-2xl border border-border/10">
          
          {}
          <div className="absolute inset-0 bg-background/5 backdrop-blur-[2px] mix-blend-overlay pointer-events-none" />
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-background/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-background/10 rounded-full blur-3xl pointer-events-none" />

          {}
          <div className="relative z-10 flex flex-col items-center gap-10">
            <div className="space-y-6 max-w-4xl mx-auto">
              <h2 className="text-5xl sm:text-6xl md:text-8xl font-extrabold tracking-tighter text-background drop-shadow-sm">
                Klaar voor de Volgende Stap?
              </h2>
              <p className="text-lg sm:text-xl md:text-2xl text-background/80 font-medium max-w-2xl mx-auto leading-relaxed">
                Laten we samenwerken om uw digitale visie werkelijkheid te maken. Ontdek wat North Websites voor uw online groei kan betekenen.
              </p>
            </div>

            <Button asChild size="lg" className="mt-4 bg-background text-foreground hover:bg-background/90 text-lg h-16 px-10 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-background/20 border border-transparent hover:border-border/20">
              <Link to="/ContactPage">
                Neem Contact Op
                <ArrowRight className="ml-3 size-6" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}